<template lang="pug">
  div.section_title(v-in-viewport.once="true")
    h2.u-visually--hidden {{ seo }}
    div.section_title-number_column
      span.section_title-number(:style="{color: color}")
        span.section_title-number_el 0
        span.section_title-number_el
          slot(name="number")
        span.section_title-number_el .
      span.section_title-number_underline(v-in-viewport.once="true" :style="{backgroundColor: color}")
    div.section_title-title
      span(:style="{color: color}")
        slot(name="text1")
      span(:style="{color: color}")
        slot(name="text2")
</template>


<script>
export default {
  name: 'SectionTitle',
  props: ['seo', 'color']
}
</script>


<style lang="sass" scoped>
  .section_title
    display: flex
    overflow: hidden
    opacity: 0
    margin: 1em 0
    &.in-viewport
      opacity: 1
      animation: .650s fadeInUp2 1ms both
    &-title
      display: block
      font-size: calc(1.8rem + (6 - 3.4) * (100vw - 32rem)/ (76.8 - 32))
      font-weight: 800
      line-height: 1
      padding-top: .4em
      > span
        display: block
      +breakpoint(sm)
        font-size: calc(1.8rem + (6 - 3.4) * (100vw - 32rem)/ (76.8 - 32))
        padding-top: .3em
      +breakpoint(md)
        font-size: calc(1.75rem + (6 - 3.4) * (100vw - 32rem)/ (76.8 - 32))
        padding-top: .25em
      +breakpoint(lg)
        font-size: calc(1.65rem + (6 - 3.4) * (100vw - 32rem)/ (76.8 - 32))
      +breakpoint(xl)
        font-size: calc(1.4rem + (6 - 3.4) * (100vw - 32rem)/ (76.8 - 32))
    &-number
      // color: [color]
      display: inline-block
      font-size: calc(2.8rem + (6 - 3.2) * (100vw - 32rem)/ (76.8 - 32))
      font-weight: 800
      line-height: 1.4
      &_column
        display: flex
        flex-direction: column
        margin-right: calc(1.9rem + (2.5 - 2) * (100vw - 32rem)/ (76.8 - 32))
        overflow: hidden
      &_underline
        display: inline-block
        height: calc(.2rem + (1 - .5) * (100vw - 32rem)/ (76.8 - 32))
        width: 0
        &.in-viewport
          transition: width ease .750s
          width: 100%

</style>



// WEBPACK FOOTER //
// src/components/SectionTitle.vue